module.exports = __webpack_public_path__ + "static/media/drizzle.3c3e9f40.svg";